export default __webpack_public_path__ + "ddc43af6c65bb9d55749aba6c5eeda7a.jpg";